var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92902 2.72538C9.91272 2.73499 9.89561 2.75031 9.881 2.77975L7.7164 7.13992C7.62516 7.32371 7.44953 7.451 7.24648 7.48051L2.40577 8.18401C2.29317 8.20037 2.25852 8.33046 2.3317 8.40133L5.83379 11.7929C5.98223 11.9366 6.05002 12.1444 6.01489 12.3481L5.18839 17.1394C5.18288 17.1714 5.18768 17.1928 5.19467 17.2089C5.20272 17.2275 5.21764 17.2472 5.23984 17.2632C5.26203 17.2792 5.28628 17.2878 5.30825 17.2899C5.3277 17.2917 5.35165 17.2892 5.38207 17.2733L9.71084 15.0098C9.89226 14.915 10.1086 14.915 10.29 15.0098L14.6188 17.2733C14.6492 17.2892 14.6732 17.2917 14.6926 17.2899C14.7146 17.2878 14.7389 17.2792 14.7611 17.2632C14.7832 17.2472 14.7982 17.2275 14.8062 17.2089C14.8132 17.1928 14.818 17.1714 14.8125 17.1394L13.986 12.3481C13.9509 12.1444 14.0187 11.9366 14.1671 11.7929L17.6692 8.40133C17.7424 8.33046 17.7077 8.20037 17.5951 8.18401L12.7544 7.48051C12.5514 7.451 12.3757 7.32371 12.2845 7.13992L10.1199 2.77975C10.1053 2.75031 10.0882 2.73499 10.0719 2.72538C10.0533 2.71444 10.0286 2.70703 10.0004 2.70703C9.97234 2.70703 9.94759 2.71444 9.92902 2.72538ZM8.76138 2.22391C9.269 1.2014 10.7319 1.2014 11.2395 2.22391L13.2584 6.29063L17.7749 6.947C18.9045 7.11116 19.3649 8.49923 18.5388 9.29927L15.2739 12.461L16.0443 16.927C16.2398 18.0605 15.0468 18.9076 14.0396 18.381L10.0004 16.269L5.96127 18.381C4.95413 18.9076 3.76105 18.0605 3.95659 16.927L4.72695 12.461L1.4621 9.29927C0.635989 8.49923 1.09641 7.11116 2.22599 6.947L6.74247 6.29063L8.76138 2.22391Z",
    fill: "#656579"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9b238b0c145860744719d9817ecd0895.svg";
export { ForwardRef as ReactComponent };